import _ from 'lodash'

import { sortOrderKeys } from '../../configuration/sorting'

import { CONFIGURE_SORT_ORDER, SET_SORT_ORDER } from '../actions/applySortOrder'

const initialState = sortOrderKeys.popAsc

export default function sorting(state = initialState, action) {
  switch (action.type) {
    case CONFIGURE_SORT_ORDER:
      return action.payload
    case SET_SORT_ORDER:
      return action.payload
    default:
      return state
  }
}

export const getSortOrder = state => _.get(state, 'sortingData')
